import { css } from '@emotion/css'
import { spacing, borderRadius, zIndex, fontSize, fontFamily, lineHeight } from '../../styles'
import { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'
import { scrollGradient } from '../../utils/styleUtils'

const styles = {
  wrapper: css({
    position: 'relative',
  }),

  labelDefault: css({
    fontSize: fontSize.default,
  }),

  labelMedium: css({
    fontSize: fontSize.medium,
  }),

  label: css({
    position: 'relative',
    zIndex: zIndex.level8,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: colors.oxfordBlue,
    fontFamily: fontFamily.body,
    height: 1.2,
    lineHeight: lineHeight.default,
    padding: 0,
    userSelect: 'none',

    '&:hover': {
      textDecoration: 'underline',
    },

    '&:focus': {
      textDecoration: 'underline',
      outline: 'none',
    },

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  disabled: css({
    color: colors.grayChateau,
    pointerEvents: 'none',
  }),

  body: css({
    marginTop: spacing.extraSmall,
    backgroundColor: colors.white,
    position: 'absolute',
    top: '100%',
    left: '100%',
    transform: 'translateX(-70px)',
    zIndex: zIndex.level8,
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.mystic}`,
    boxShadow: `0 2px 4px ${hexToRgba(colors.black, 0.1)}`,

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 48,
      width: 10,
      height: 10,
      backgroundColor: colors.white,
      borderLeft: `1px solid ${colors.mystic}`,
      borderTop: `1px solid ${colors.mystic}`,
      transform: 'rotate(45deg) translateY(-9px)',
      zIndex: 0,
    },
  }),

  list: css({
    whiteSpace: 'nowrap',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    overflowY: 'auto',
    position: 'relative',
    zIndex: 1,

    '& > * + *': {
      borderTop: `1px solid ${colors.mystic}`,
    },
  }),

  listMaxHeight: height =>
    css({
      ...scrollGradient,
      maxHeight: height,
    }),

  overlay: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex.level7,
  }),
}

export default styles
